import { batch } from 'react-redux';
import { Response } from 'express';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { doRequest } from '@r1-frontend/do-request';
import { getInfoAll } from '@r1-frontend/api-domru/api-profile/v2/info/all';
import { ResponseContactDto } from '@r1-frontend/api-domru/api-profile/v2/info/all/dto/ResponseDto';
import {
    setClientContacts,
    setClientInfoStage,
    setClientPayment,
    setClientPersonal,
    setClientProducts,
    setErrorClientPayment,
    setFetchClientPayment,
} from '@r1-frontend/entities/stores/auth/actionCreators';
import { catch401 } from '@r1-frontend/entities/stores/auth/helpers/catch401';
import { EStage, IClientContacts, TState } from '@r1-frontend/entities/stores/auth/reducer';
import selectProviderId from '@r1-frontend/entities/stores/city/selectors/selectProviderId';

import { getAgreementNumber } from '@r1-frontend/shared/helpers/getAgreementNumber';
import { isServerSide } from '@r1-frontend/shared/helpers/ssr';

export const parseContacts = (_contacts: ResponseContactDto['contacts']): IClientContacts => {
    const { contacts } = _contacts;
    return {
        email: contacts.email.map((el) => ({
            ...el,
            value: el.contactValue,
        })),
        phone: contacts.phone.map((el) => ({
            ...el,
            value: el.contactValue,
        })),
    };
};


/**
 * Информация о клиенте
 */
/** @deprecated use frontend/apps/b2c-domru/src/store/actions/auth/getInfoAll.ts **/
export const fetchClientInfo = (response?: Response, agreementNumber?: string) => {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState) => {
        const state = getState();

        const providerId = selectProviderId(state);
        const accessToken = state.auth.accessToken;
        const isFetching = state.auth.clientPaymentFetching;
        const agreement = agreementNumber || getAgreementNumber();

        if (!providerId || !accessToken || isFetching) {
            return;
        }

        dispatch(setFetchClientPayment(true));
        // актуальные статусы
        dispatch(setClientInfoStage({
            payment: EStage.loading,
            contacts: EStage.loading,
            products: EStage.loading,
            personal: EStage.loading,
        }));

        const resp = await doRequest.apiProfile<ResponseContactDto>(
            getInfoAll(providerId, accessToken, agreement, ['personal', 'payment', 'products', 'contacts']),
        );

        if (resp.isSuccess) {
            const { personal, payment, products, contacts } = resp.payload;

            batch(() => {
                dispatch(setClientPersonal(personal));
                dispatch(setClientPayment(payment));
                dispatch(setClientProducts(products));
                dispatch(setClientContacts(parseContacts(contacts)));
                dispatch(setClientInfoStage({
                    payment: EStage.loaded,
                    contacts: EStage.loaded,
                    products: EStage.loaded,
                    personal: EStage.loaded,
                }));
            });
        } else {
            if (catch401(resp.error, response)) {
                return;
            }

            if (isServerSide()) {
                console.log({ event: 'Ошибка при вызове getInfoAll', ...resp.error });
            }
        }

        dispatch(setErrorClientPayment(false));
    };
};
